var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessibilityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77724 16.2114C11.2916 13.5885 13.5019 11.4354 16.1636 9.99018C18.8253 8.54498 21.8349 7.864 24.8595 8.02251C27.8841 8.18102 30.806 9.17286 33.302 10.8884C35.7981 12.6039 37.7712 14.9762 39.0031 17.7431M6 11.1108L7.49739 17.5969C7.75243 18.7016 8.85472 19.3904 9.95944 19.1354L16.4456 17.638M38.2228 32.6341C36.7084 35.2571 34.4981 37.4102 31.8364 38.8554C29.1747 40.3006 26.1651 40.9816 23.1405 40.823C20.1159 40.6645 17.194 39.6727 14.698 37.9572C12.2019 36.2417 10.2288 33.8693 8.9969 31.1025M42 37.7347L40.5026 31.2486C40.2476 30.1439 39.1453 29.4551 38.0406 29.7102L31.5544 31.2075",
    stroke: "#FF00FF",
    strokeWidth: 2.05247,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessibilityIcon);
export default __webpack_public_path__ + "static/media/accessibility-icon.299fc4f16eac8cb8ac18094dfde5927d.svg";
export { ForwardRef as ReactComponent };